export enum PolicyContext {
  ADD = 'add',
  EDIT = 'edit',
  CLONE = 'clone',
}

export interface NavigationHeaderSlice {
  policyName: string;
  context: PolicyContext;
  updateNeeded: boolean;
}
